import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  constructor(
    private _meta: Meta,
    private _title: Title,
  ) {
    this._title.setTitle(`Kontakt | Salon Expert L'Oréal Professionnel`);
    this._meta.updateTag({ property: 'og:title', content: `Kontakt | Salon Expert L'Oréal Professionnel` });
  }

  ngOnInit() {
  }

}
